import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const TooltipComponent = ({ id, title }) => {
  if (!id || !title) return null;

  const Overlay = (
    <Tooltip id={id} placement="top">
      {title}
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="top" overlay={Overlay}>
      <span className="field-info" />
    </OverlayTrigger>
  );
};

export default TooltipComponent;
